export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

/**
 * 时间字符串的比较方法
 * @param timeStr1
 * @param timeStr2
 * @returns {number}
 */
export function timeCompare(timeStr1, timeStr2) {
  timeStr1 = timeStr1 == null ? getTimestamp(null) : timeStr1
  timeStr2 = timeStr2 == null ? getTimestamp(null) : timeStr2

  // 预编译正则表达式
  const timeRegex = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/

  const toTimestamp = str => {
    const [, y, m, d, h, i, s] = timeRegex.exec(str)
    return Date.UTC(y, m - 1, d, h, i, s)
  }

  const t1 = toTimestamp(timeStr1)
  const t2 = toTimestamp(timeStr2)

  return Math.sign(t1 - t2) // 1: 大于, 0: 等于, -1: 小于
}

/**
 * 根据传入时间转化成年-月-日 时:分:秒
 * @param date
 * @returns {function(): string}
 */
export function getTimestamp (date) {
  const pad = n => n.toString().padStart(2, '0') // 缓存补零函数
  return () => {
    const d = date == null ? new Date() : date
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  }
}
